import { render, staticRenderFns } from "./PieChart.vue?vue&type=template&id=3d173562&scoped=true"
import script from "./PieChart.vue?vue&type=script&lang=js"
export * from "./PieChart.vue?vue&type=script&lang=js"
import style0 from "./PieChart.vue?vue&type=style&index=0&id=3d173562&prod&scoped=true&lang=css"
import style1 from "./PieChart.vue?vue&type=style&index=1&id=3d173562&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d173562",
  null
  
)

export default component.exports